module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.ff73c2bb.webp";